module.exports = __webpack_public_path__ + "img/appD32.d3a9b904.svg";